/**
 * 此文件用于定义自定义blockly积木块
 */
const Blockly = window.Blockly;
const baseUrl = process.env.BASE_URL;
const Cookies = window.Cookies;
import utils from "@/service/utils";
import {jointRotateConfig} from "./joint-rotate-config";
export default function () {
  //不能被放置到有返回的流程中的塊
  const cantSuroundedInDefreturnBlocks = "control_wait_for,nuwa_control_hear_something,control_parallel,control_if,control_ifElse,control_repeat_times,control_repeat_forever,control_delay,drive_turn_v1,drive_ward_v1,body_head_sagittal_new,body_head_horizontal_new,body_shoulder_left_horizontal,body_shoulder_left_sagittal,body_shoulder_left_frontal,body_elbow_left_sagittal,body_shoulder_right_horizontal,body_shoulder_right_sagittal,body_shoulder_right_frontal,body_elbow_right_sagittal,motion_face,motion_special_image,other_function_camera,other_function_video,light_all,light_head,light_hand_left,light_hand_right,light_belly,sound_say,sound_say2,sound_animal,sound_scale,sound_effect,sound_background,sound_record,motion_general,motion_emotion,motion_naughty_2,motion_festival,material_lib_role,material_lib_image,material_lib_video,material_lib_audio,material_lib_motion material_lib_content material_lib_dance,stop_excute".split(",");
  //不能被放置到循环、重复、有返回值的流程中的块
  const cantSuroundMqttBlocks = ["procedures_defreturn", "control_repeat_times", "control_repeat_forever", "controls_whileUntil", "controls_for", "controls_forEach"];
  
  //跳到開始塊不能被放置的塊
  const cantSuroundReturnToStartBlocks = ["procedures_defreturn","procedures_defnoreturn","control_parallel","control_if","control_ifElse","control_repeat_times","control_repeat_forever","controls_whileUntil","controls_for","controls_forEach","controls_if", "start_function"];
  //不能包含重置機器人的塊
  const cantSuroundResetRobotBlocks = ["procedures_defreturn","control_parallel"];

  //显示块警告
  function showBlockWarn(block, warnText){
    block.setWarningText(warnText);
    block.suroundAbled_ = false;
    block.isInFlyout || block.getInheritedDisabled() || block.setDisabled(true);
  }

  //移除块警告
  function removeBlockWarn(block){
    block.setWarningText(null);
    block.suroundAbled_ = true;
    block.isInFlyout || block.setDisabled(block.defaultDisabled_);
  }
  //工作空间中是否有MQTT连线块被使用
  function hasMqttConnectBlock(name){
    var workSpace = Blockly.getMainWorkspace();
    var mqttBlocks = workSpace.getBlocksByType(name);
    if(mqttBlocks.length === 0){
      return false;
    } else {
      return !!mqttBlocks.find(block => {
        return !block.disabled;
      });
    }
  }
  // 定制块change事件回调
  function initBlockChangeFunc(suroundBlockTypes = [], warn = "", isCant = true, callback = () => {}){
    return function onCustomBlockChange (e) {
      if(e.blockId !== this.id && e.type === "change"){
        if(e.element === "disabled"){
          callback(this, e);
        }
        return;
      }
      if(this.defaultDisabled_ === undefined){
        this.defaultDisabled_ = false;
      }
      if(e.type === "change" && e.element === "disabled" && this.suroundAbled_){
        this.defaultDisabled_ = e.newValue;
      }
      if (this.workspace.isDragging && !this.workspace.isDragging() && e.type !== "ui") {
        if(suroundBlockTypes.length > 0){
          var a = false, b = this; 
          do { 
              if (-1 != suroundBlockTypes.indexOf(b.type)) { 
                  a = true;
                  break 
              } 
              b = b.getSurroundParent(); 
          } while (b);
          if(a === isCant){
            showBlockWarn(this, (Blockly.Msg[warn] || warn || ""));
          } else {
            removeBlockWarn(this);
            callback(this, e);
          }
        } else {
          callback(this, e);
        }
      }
    };
  };

  // 开始目录
  Blockly.defineBlocksWithJsonArray([
    { // 开始
      "type": "start_start",
      "message0": "%{BKY_NUWA_START}",
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_START_COLOR}",
      "tooltip": "%{BKY_NUWA_START}",
      "helpUrl": ""
    },
    { // 当机器人
      "type": "start_when_v2",
      "message0": "%{BKY_NUWA_WHEN_ROBOT3}",
      "args0": [
        {
          "type": "field_robot_event",
          "name": "input1"
        }
      ],
      "inputsInline": true,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_START_COLOR}",
      "tooltip": "%{BKY_TEXT_ISEMPTY_TOOLTIP}",
      "helpUrl": ""
    },
    { // 跳到开始
      "type": "start_goto_start",
      "message0": "%{BKY_NUWA_JUMP2_START}",
      "previousStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_START_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_BACK_START}",
      "helpUrl": ""
    },
    { // 結束程式
      "type": "stop_excute",
      "message0": "%{BKY_NUWA_STOP_EXCUTE}",
      "previousStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_START_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_STOP_EXCUTE}",
      "helpUrl": ""
    },
    {// 复位机器人
      "type": "reset_robot",
      "message0": "%{BKY_NUWA_RESET_ROBOT}",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "input1",
          "options": [
            [
              "%{BKY_NUWA_TEXT_OPTIONS_RESET_ROBOT_0}",
              "0"
            ],
            [
              "%{BKY_NUWA_TEXT_OPTIONS_RESET_ROBOT_1}",
              "1"
            ],
            [
              "%{BKY_NUWA_TEXT_OPTIONS_RESET_ROBOT_2}",
              "2"
            ],
            [
              "%{BKY_NUWA_TEXT_OPTIONS_RESET_ROBOT_3}",
              "3"
            ],
            [
              "%{BKY_NUWA_TEXT_OPTIONS_RESET_ROBOT_4}",
              "4"
            ]
          ]
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_START_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_RESET_ROBOT}",
      "helpUrl": ""
    }
  ]);
  //设置开始块不可被删除
  Blockly.Blocks.start_start.deletable_ = false;
  Blockly.Blocks.start_start.editable_ = false;
  // 控制目录
  Blockly.defineBlocksWithJsonArray([
    { // 等待机器人
      "type": "control_wait_for",
      "message0": "%{BKY_NUWA_WAIT_ROBOT_WHEN}",
      "args0": [
        {
          "type": "field_robot_event",
          "name": "input1"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_CONTROL_COLOR}",
      "tooltip": "",
      "helpUrl": ""
    },
    {
      //等待機器人聽到什麼內容
      "type": "nuwa_control_hear_something",
      "message0": "%{BKY_NUWA_WHEN_HEAR_SOMETHING}",
      "args0": [
        {
          "type": "field_variable",
          "name": "input1",
          "variable": null
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_CONTROL_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_WHEN_HEAR_SOMETHING}",
      "helpUrl": ""
    },
    { // 同时执行
      "type": "control_parallel",
      "message0": "%{BKY_NUWA_RUN_MAINWHILE}",
      "args0": [
        {
          "type": "input_dummy"
        },
        {
          "type": "input_statement",
          "name": "do1"
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_CONTROL_COLOR}",
      "tooltip": "%{BKY_NUMWA_TOOLTIP_RUN_MAINWHILE}",
      "helpUrl": ""
    },
    { // 如果机器人 xx : xx
      "type": "control_if",
      "message0": "%{BKY_NUWA_IF_ROBOT}",
      "args0": [
        {
          "type": "field_robot_event",
          "name": "input1"
        },
        {
          "type": "input_dummy"
        },
        {
          "type": "input_statement",
          "name": "do1"
        }
      ],
      "previousStatement": null,
      "inputsInline": true,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_CONTROL_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_IF_ROBOT_DO}",
      "helpUrl": ""
    },
    { // 如果机器人 xx : xx，否则 xx
      "type": "control_ifElse",
      "message0": "%{BKY_NUWA_IF_ROBOT_ELSE}",
      "args0": [
        {
          "type": "field_robot_event",
          "name": "input1"
        },
        {
          "type": "input_dummy"
        },
        {
          "type": "input_statement",
          "name": "do1"
        },
        {
          "type": "input_statement",
          "name": "do2" 
        }
      ],
      "previousStatement": null,
      "inputsInline": true,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_CONTROL_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_IF_ROBOT_DO}",
      "helpUrl": ""
    },
    {
      "type": "control_repeat_times",//重复n次执行
      "message0": "%{BKY_NUWA_TEXT_CONTROL_REPEAT_TIMES}",
      "args0": [{
        "type": "field_number",
        "name": "input1",
        "value": 3,
        "min": 1,
        "max": 90
      },
      {
        "type": "input_dummy"
      },
      {
        "type": "input_statement",
        "name": "input2"
      }],
      inputsInline: !0,
      previousStatement: null,
      nextStatement: null,
      colour: "%{BKY_NUWA_CATEGORY_CONTROL_COLOR}",
      tooltip: "",
      helpUrl: ""
    },
    {
      type: "control_repeat_forever",//永久重复
      message0: "%{BKY_NUWA_TEXT_CONTROL_REPEAT_FOREVER}",
      args0: [{
        type: "input_dummy"
      }, {
        type: "input_statement",
        name: "input2"
      }],
      inputsInline: !0,
      previousStatement: null,
      nextStatement: null,
      colour: "%{BKY_NUWA_CATEGORY_CONTROL_COLOR}",
      tooltip: "",
      helpUrl: ""
    },
    { // 等待n秒
      "type": "control_delay",
      "message0": "%{BKY_NUWA_ROBOT_WAIT_TIME}",
      "args0": [
        {
          "type": "field_number",
          "name": "input1",
          "value": 1,
          "min": 0,
          "max": 300,
          "precision": 1
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_CONTROL_COLOR}",
      "tooltip": "",
      "helpUrl": ""
    },
  ]);
  // 动作目录
  function getMotorSpeedOptions(){
    return [
      ["%{BKY_NUWA_SLOW_SPEED}", "0"],
      ["%{BKY_NUWA_MIDDLE_SPEED}", "1"],
      ["%{BKY_NUWA_HIGHT_SPEEND}", "2"]
    ];
  }
  function getJointRoteteOptions(){
    let options = jointRotateConfig.map(item => {
      let label = item.optionLabel;
      let key = item.key;
      return [
        label,
        function(field){
          if(!field){
            return key
          }
          let sourceBlock = field.sourceBlock_;
          if(sourceBlock){
            let input2 = sourceBlock.getField("input2");
            if(input2){
              input2.setValue(1);
            }
            let input4 = sourceBlock.getField("input4");
            if(input4){
              let methodLabel = getJointRotateSufifx(key);
              input4.setValue(methodLabel)
            }
          }
          setTimeout(() => {
            field.value_ = key;
            field.text_ = getJointRotateValueText(key);
            Blockly.WidgetDiv.hideIfOwner(field);
            Blockly.Events.setGroup(false);
            field.forceRerender()
          }, 0)
        }
      ]
    })
    return options;
  }
  function getJointRotateSufifx(jointId){
    let jointConfig = jointRotateConfig.find(item => item.key === jointId);
    let suffix = jointConfig ? jointConfig.suffix : "%{BKY_NUWA_TEXT_ACTION_SUFFIX}";
    return Blockly.utils.replaceMessageReferences(suffix); 
  }
  function getJointRotateValueText(jointId){
    let jointConfig = jointRotateConfig.find(item => item.key === jointId);
    let text = jointConfig ? jointConfig.label : "%{BKY_NUWA_TEXT_PLACEHOLDER_SELECT_ACTION_JOINT}";
    return Blockly.utils.replaceMessageReferences(text);
  }
  Blockly.defineBlocksWithJsonArray([
    { // 旋转
      "type": "drive_turn_v1",
      "message0": "%{BKY_NUWA_ROTATE}",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "input1",
          "options": [
            [
              "%{BKY_NUWA_TO_LEFT}",
              "0"
            ],
            [
              "%{BKY_NUWA_TO_RIGHT}",
              "1"
            ]
          ]
        },
        {
          "type": "field_dropdown",
          "name": "input2",
          "value": "30",
          "options": [
            ["%{BKY_NUWA_MIDDLE_SPEED}", "30"]
          ]
        },
        {
          "type": 'field_joint_angle',
          "name": 'input3',
          "min": 0,
          "max": 359,
          "value": 0, 
          "bg": {
            width: 200,
            height: 200,
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/R0_0_Robot_Rotate/R0_0_Robot_Rotate_Model.png"
          },
          "symbol": ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/R0_0_Robot_Rotate/R0_0_Robot_Rotate_Pointer.png",
          "transform": {
            x: 0,
            y: 0,
            cx: 100,
            cy: 100,
          },
          "initAngle": 90,
          "title": function(field){
            if(field && field.sourceBlock_){
              let directionValue = field.sourceBlock_.getField('input1').getValue()
              if(directionValue === "0"){
                return Blockly.utils.replaceMessageReferences('%{BKY_NUWA_TEXT_TURN_TO_LEFT}')
              } else {
                return Blockly.utils.replaceMessageReferences('%{BKY_NUWA_TEXT_TURN_TO_RIGHT}')
              } 
            } else {
              return Blockly.utils.replaceMessageReferences('%{BKY_NUWA_TEXT_TURN_TO_LEFT}')
            }
          },
          "clockWise": function(field){
            if(field && field.sourceBlock_){
              let directionValue = field.sourceBlock_.getField('input1').getValue()
              if(directionValue === "0"){
                return -1
              } else {
                return 1
              }
            } else {
              return -1
            }
          }
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MOTION_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_ROBOT_ROTATE}",
      "helpUrl": ""
    },
    { // 移动
      "type": "drive_ward_v1",
      "message0": "%{BKY_NUWA_ROBOT_MOVE}",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "input1",
          "options": [
            [
              "%{BKY_NUWA_TO_FRONTEND}",
              "2"
            ],
            [
              "%{BKY_NUWA_TO_BEHIND}",
              "3"
            ]
          ]
        },
        {
          "type": "field_dropdown",
          "name": "input2",
          "value": "10",
          "options": [
            ["%{BKY_NUWA_SLOW_SPEED}", "5"],
            ["%{BKY_NUWA_MIDDLE_SPEED}", "10"],
            ["%{BKY_NUWA_HIGHT_SPEEND}", "20"]
          ]
        },
        {
          "type": "field_number",
          "name": "input3",
          "value": 0,
          "min": 0,
          "max": 127,
          'precision': 1
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MOTION_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_ROBOT_MOVE}",
      "helpUrl": ""
    },
    {//肢體動作
      "type": "nuwa_rotate_joint",
      "message0": "%{BKY_NUWA_JOINT_ROTATE}",
      "args0": [
        {
          "type": "field_dynamic_dropdown",
          "name": "input1",
          "placeholder": "%{BKY_NUWA_TEXT_PLACEHOLDER_SELECT_ACTION_JOINT}",
          "options": function(){
            const options = getJointRoteteOptions();
            return options;
          }
        },
        {
          "type": "field_dynamic_dropdown",
          "name": "input2",
          "placeholder": "%{BKY_NUWA_TEXT_PLACEHOLDER_SELECT_SPEED}",
          "options": function(field){
              let options = getMotorSpeedOptions();
              setTimeout(() => {
                let sourceBlock = field.sourceBlock_;
                if(sourceBlock){
                  let input1 = sourceBlock.getField("input1");
                  let input1Value = input1.getValue();
                  if(!sourceBlock.hasInited){
                    sourceBlock.hasInited = true;
                    if(input1){
                      let oldText = input1.text_;
                      let newText = getJointRotateValueText(input1Value);
                      if(newText !== oldText){
                        input1.text_ = newText;
                      }
                    }
                    let input4 = sourceBlock.getField("input4");
                    if(input4){
                      let oldLabel = input4.getValue();
                      let methodLabel = getJointRotateSufifx(input1Value);
                      if(oldLabel !== methodLabel){
                        input4.setValue(methodLabel)
                      }
                      if(input4.fieldGroup_ && input4.fieldGroup_.classList){
                        input4.fieldGroup_.classList.add("nuwa_disabled")
                      }
                    }
                  }
                }
              });
            return options;
          }
        },
        {
          "type": "field_input",
          "name": "input4",
          "text": getJointRotateSufifx()
        },
        {
          "type": "input_value",
          "name": "input3",
          "check": "Number"
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MOTION_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_ROTATE_JOINT}",
      "helpUrl": ""
    },
    {//角度
      "type": "nuwa_angle",
      "message0": "%1",
      "args0": [
        {
          "type": "field_angle",
          "name": "input1",
          "angle": 0
        }
      ],
      "output": "Number",
      "colour": "%{BKY_NUWA_CATEGORY_MOTION_COLOR}",
      "tooltip": "",
      "helpUrl": ""
    },
    { // 头部上下移动
      "type": "body_head_sagittal_new",
      "message0": "%{BKY_NUWA_HEAD_UP_DOWN}",
      "args0": [
        {
          "type": 'field_joint_angle',
          "name": 'input1',
          "min": -20,
          "max": 20,
          "value": 0, 
          "preValue": "-1,-1,",
          "bg": {
            width: 200,
            height: 270,
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/H01_1_Head_Vertical/H01_1_Head_Vertical_Model.png"
          },
          "symbol": ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/H01_1_Head_Vertical/H01_1_Head_Vertical_Pointer.png",
          "transform": {
            x: 0,
            y: 34,
            cx: 100,
            cy: 100,
          },
          "initAngle": 180,
        },
        {
          "type": "field_dropdown",
          "name": "input2",
          "value": "1",
          "options": getMotorSpeedOptions()
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MOTION_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_ROBOT_HEAD_UP_DOWN}",
      "helpUrl": ""
    },
    { // 头部左右移动
      "type": "body_head_horizontal_new",
      "message0": "%{BKY_NUWA_HEAD_LEFT_RIGHT}",
      "args0": [
        {
          "type": 'field_joint_angle',
          "name": 'input1',
          "min": -30,
          "max": 30,
          "value": 0, 
          "preValue": "-1,2,",
          "bg": {
            width: 200,
            height: 200,
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/H01_3_Head_Horizontal/H01_3_Head_Horizontal_Model.png"
          },
          "symbol": ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/H01_3_Head_Horizontal/H01_3_Head_Horizontal_Pointer.png",
          "transform": {
            x: 0,
            y: 0,
            cx: 100,
            cy: 100,
          },
          "initAngle": 90,
          "clockWise": -1
        },
        {
          "type": "field_dropdown",
          "name": "input2",
          "value": "1",
          "options": getMotorSpeedOptions()
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MOTION_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_ROBOT_HEAD_LEFT_RIGHT}",
      "helpUrl": ""
    },
    { // 左肩内转
      "type": "body_shoulder_left_horizontal",
      "message0": "%{BKY_NUWA_LEFT_SHOULDER_ROTATE1}",
      "args0": [
        {
          "type": 'field_joint_angle',
          "name": 'input1',
          "min": 0,
          "max": 90,
          "value": 0, 
          "preValue": "7,-1,",
          "bg": {
            width: 286,
            height: 200,
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/L01_1_Shoulder_Adduct/L01_1_Shoulder_Adduct_Model.png"
          },
          "symbol": ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/L01_1_Shoulder_Adduct/L01_1_Shoulder_Adduct_Pointer.png",
          "transform": {
            x: 43,
            y: 0,
            cx: 100,
            cy: 100,
          },
          "initAngle": 0,
        },
        {
          "type": "field_dropdown",
          "name": "input2",
          "value": "1",
          "options": getMotorSpeedOptions()
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MOTION_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_LEFT_SHOULDER_ROTATE1}",
      "helpUrl": ""
    },
    { // 左肩垂直旋转
      "type": "body_shoulder_left_sagittal",
      "message0": "%{BKY_NUWA_LEFT_SHOULDER_ROTATE2}",
      "args0": [
        {
          "type": 'field_joint_angle',
          "name": 'input1',
          "min": 0,
          "max": 255,
          "value": 55,
          "preValue": "8,-1,",
          "getLabel": function(value){
            return value - 55;
          },
          "fixInputValue": function(value){
            return value + 55;
          },
          "bg": {
            width: 200,
            height: 245,
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/L01_2_Shoulder_LiftUp/L01_2_Shoulder_LiftUp_Model.png"
          },
          "symbol": ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/L01_2_Shoulder_LiftUp/L01_2_Shoulder_LiftUp_Pointer.png",
          "transform": {
            x: -1,
            y: 22,
            cx: 100,
            cy: 100,
          },
          "initAngle": 90,
        },
        {
          "type": "field_dropdown",
          "name": "input2",
          "value": "1",
          "options": getMotorSpeedOptions()
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MOTION_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_LEFT_SHOULDER_ROTATE2}",
      "helpUrl": ""
    },
    { // 左手臂水平转动
      "type": "body_shoulder_left_frontal",
      "message0": "%{BKY_NUWA_LEFT_HAND_ROTATE}",
      "args0": [
        {
          "type": 'field_joint_angle',
          "name": 'input1',
          "min": -90,
          "max": 0,
          "value": 0,
          "preValue": "9,1,",
          "getLabel": function(value){
            return -value;
          },
          "fixInputValue": function(value){
            return -value;
          },
          "bg": {
            width: 250,
            height: 242,
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/L01_3_Arm_Raise/L01_3_Arm_Raise_Model.png"
          },
          "symbol": ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/L01_3_Arm_Raise/L01_3_Arm_Raise_Pointer.png",
          "transform": {
            x: 60,
            y: 21,
            cx: 100,
            cy: 100,
          },
          "initAngle": 90,
        },
        {
          "type": "field_dropdown",
          "name": "input2",
          "value": "1",
          "options": getMotorSpeedOptions()
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MOTION_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_LEFT_HAND_ROTATE}",
      "helpUrl": ""
    },
    { // 左手肘上下旋转
      "type": "body_elbow_left_sagittal",
      "message0": "%{BKY_NUWA_LEFT_ELBOW_ROTATE}",
      "args0": [
        {
          "type": 'field_joint_angle',
          "name": 'input1',
          "min": 0,
          "max": 75,
          "value": 0, 
          "preValue": "10,-1,",
          "bg": {
            width: 200,
            height: 385,
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/L01_4_Elbow_LiftUp/L01_4_Elbow_LiftUp_Model.png"
          },
          "symbol": ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/L01_4_Elbow_LiftUp/L01_4_Elbow_LiftUp_Pointer.png",
          "transform": {
            x: 0,
            y: 93,
            cx: 100,
            cy: 100,
          },
          "initAngle": 90,
        },
        {
          "type": "field_dropdown",
          "name": "input2",
          "value": "1",
          "options": getMotorSpeedOptions('10,-1')
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MOTION_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_LEFT_ELBOW_ROTATE}",
      "helpUrl": ""
    },
    { // 右肩膀水平旋转
      "type": "body_shoulder_right_horizontal",
      "message0": "%{BKY_NUWA_RIGHT_SHOULDER_ROTATE1}",
      "args0": [
        {
          "type": 'field_joint_angle',
          "name": 'input1',
          "min": 0,
          "max": 90,
          "value": 0,
          "preValue": "3,-1,",
          "bg": {
            width: 286,
            height: 200,
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/R01_1_Shoulder_Adduct/R01_1_Shoulder_Adduct_Model.png"
          },
          "symbol": ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/R01_1_Shoulder_Adduct/R01_1_Shoulder_Adduct_Pointer.png",
          "transform": {
            x: 43,
            y: 0,
            cx: 100,
            cy: 100,
          },
          "initAngle": 180,
          "clockWise": -1
        },
        {
          "type": "field_dropdown",
          "name": "input2",
          "value": "1",
          "options": getMotorSpeedOptions()
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MOTION_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_RIGHT_SHOULDER_ROTATE1}",
      "helpUrl": ""
    },
    { //  右肩垂直旋转
      "type": "body_shoulder_right_sagittal",
      "message0": "%{BKY_NUWA_RIGHT_SHOULDER_ROTATE2}",
      "args0": [
        {
          "type": 'field_joint_angle',
          "name": 'input1',
          "min": 0,
          "max": 255,
          "value": 55, 
          "preValue": "4,-1,",
          "getLabel": function(value){
            return value - 55
          },
          "fixInputValue": function(value){
            return value + 55;
          },
          "bg": {
            width: 200,
            height: 245,
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/R01_2_Shoulder_LiftUp/R01_2_Shoulder_LiftUp_Model.png"
          },
          "symbol": ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/R01_2_Shoulder_LiftUp/R01_2_Shoulder_LiftUp_Pointer.png",
          "transform": {
            x: 0,
            y: 23,
            cx: 100,
            cy: 100,
          },
          "initAngle": 90,
          "clockWise": -1
        },
        {
          "type": "field_dropdown",
          "name": "input2",
          "value": "1",
          "options": getMotorSpeedOptions()
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MOTION_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_RIGHT_SHOULDER_ROTATE2}",
      "helpUrl": ""
    },
    { // 右手臂水平旋转
      "type": "body_shoulder_right_frontal",
      "message0": "%{BKY_NUWA_RIGHT_HAND_ROTATE}",
      "args0": [
        {
          "type": 'field_joint_angle',
          "name": 'input1',
          "min": -90,
          "max": 0,
          "value": 0, 
          "preValue": "5,1,",
          "getLabel": function(value){
            return -value;
          },
          "fixInputValue": function(value){
            return -value;
          },
          "bg": {
            width: 250,
            height: 242,
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/R01_3_Arm_Raise/R01_3_Arm_Raise_Model.png"
          },
          "symbol": ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/R01_3_Arm_Raise/R01_3_Arm_Raise_Pointer.png",
          "transform": {
            x: -9,
            y: 21,
            cx: 100,
            cy: 100,
          },
          "initAngle": 90,
          "clockWise": -1
        },
        {
          "type": "field_dropdown",
          "name": "input2",
          "value": "1",
          "options": getMotorSpeedOptions()
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MOTION_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_RIGHT_HAND_ROTATE}",
      "helpUrl": ""
    },
    { // 右手肘上下旋转
      "type": "body_elbow_right_sagittal",
      "message0": "%{BKY_NUWA_RIGHT_ELBOW_ROTATE}",
      "args0": [
        {
          "type": 'field_joint_angle',
          "name": 'input1',
          "min": 0,
          "max": 75,
          "value": 0, 
          "preValue": "6,-1,",
          "bg": {
            width: 200,
            height: 385,
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/R01_4_Elbow_LiftUp/R01_4_Elbow_LiftUp_Model.png"
          },
          "symbol": ""+ baseUrl +"static/js/blockly/media/nuwa/joint_angle_controll/R01_4_Elbow_LiftUp/R01_4_Elbow_LiftUp_Pointer.png",
          "transform": {
            x: 0,
            y: 93,
            cx: 100,
            cy: 100,
          },
          "initAngle": 90,
          "clockWise": -1
        },
        {
          "type": "field_dropdown",
          "name": "input2",
          "value": "1",
          "options": getMotorSpeedOptions()
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MOTION_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_RIGHT_ELBOW_ROTATE}",
      "helpUrl": ""
    },
  ]);
  // 脸部目录
  Blockly.defineBlocksWithJsonArray([
    { // 脸部表情
      "type": "motion_face",
      "message0": "%{BKY_NUWA_FACIAL_EXPRESSION}",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "input1",
          "bg": "%{BKY_NUWA_CATEGORY_FACE_COLOR}",
          "options": [
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/face_charector/img_mc_character_1_manager.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_FACIAL_OPTION_SHOPKEEPER}"
            }, "img_mc_character_master"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/face_charector/img_mc_character_2_star.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_FACIAL_OPTION_STAR}"
            }, "img_mc_character_star"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/face_charector/img_mc_character_3_poo.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_FACIAL_OPTION_POOP}"
            }, "img_mc_character_poo"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/face_charector/img_mc_character_4_zombie.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_FACIAL_OPTION_ZOMBIE}"
            }, "img_mc_character_zombie"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/face_charector/img_mc_character_5_fighter.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_FACIAL_OPTION_FIGHT}"
            }, "img_mc_character_fighter"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/face_charector/img_mc_character_6_monster.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_FACIAL_OPTION_NIAN}"
            }, "img_mc_character_monster"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/face_charector/img_mc_character_7_pumpkin.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_FACIAL_OPTION_PUMPKIM}"
            }, "img_mc_character_pumpkin"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/face_charector/img_mc_character_8_witch.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_FACIAL_OPTION_WITCH}"
            }, "img_mc_character_witch"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/face_charector/img_mc_character_9_clown.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_FACIAL_OPTION_CLOWN}"
            }, "img_mc_character_clown"]
          ]
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_FACE_COLOR}",
      "tooltip": "",
      "helpUrl": ""
    },
    { // 特殊图片
      "type": "motion_special_image",
      "message0": "%{BKY_NUWA_SPECIAL_PICTURE}",
      "args0": [{
        "type": "field_dropdown",
        "name": "input1",
        "bg": "%{BKY_NUWA_CATEGORY_FACE_COLOR}",
        "options": [
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_01.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_TRIANGLE}"
          }, "img_mc_item_01_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_02.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_HARMERNICA}"
          }, "img_mc_item_02_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_03.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_KEYBOARD}"
          }, "img_mc_item_03_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_04.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_TAPE}"
          }, "img_mc_item_04_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_05.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_PAD}"
          }, "img_mc_item_05_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_06.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_CUTTER}"
          }, "img_mc_item_06_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_07.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_BOTTLE}"
          }, "img_mc_item_07_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_08.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_PHONE}"
          }, "img_mc_item_08_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_09.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_FORK}"
          }, "img_mc_item_09_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_10.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_UMBRELLA}"
          }, "img_mc_item_10_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_11.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_BOTTLE2}"
          }, "img_mc_item_11_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_12.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_CLOCK}"
          }, "img_mc_item_12_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_13.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_SHARPENER}"
          }, "img_mc_item_13_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_14.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_PENCIL_BOX}"
          }, "img_mc_item_14_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_15.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_AUDIO_EQUIPMENT}"
          }, "img_mc_item_15_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_16.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_MOUSE}"
          }, "img_mc_item_16_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_17.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_BOOK}"
          }, "img_mc_item_17_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_18.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_TOY}"
          }, "img_mc_item_18_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_19.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_SCOTCH_TAPE}"
          }, "img_mc_item_19_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_20.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_ALARM_CLOCK}"
          }, "img_mc_item_20_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_21.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_PENCIL_CRAYON}"
          }, "img_mc_item_21_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_22.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_GLASSES}"
          }, "img_mc_item_22_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_23.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_PROTRACTOR}"
          }, "img_mc_item_23_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_24.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_GUITAR}"
          }, "img_mc_item_24_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_25.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_WATCH}"
          }, "img_mc_item_25_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_26.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_SMART_PHONE}"
          }, "img_mc_item_26_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_27.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_BOOK_BAG}"
          }, "img_mc_item_27_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_28.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_ELEC_GUITAR}"
          }, "img_mc_item_28_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_29.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_CONTROLLER}"
          }, "img_mc_item_29_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_30.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_SPOON}"
          }, "img_mc_item_30_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_31.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_TEA_POT}"
          }, "img_mc_item_31_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_32.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_TEDDY_BEAR}"
          }, "img_mc_item_32_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_33.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_GOODS_OPTION_SCISSOR}"
          }, "img_mc_item_33_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_34.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_SPECIAL_OPTION_BELLS}"
          }, "img_mc_effect_bells_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_35.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_SPECIAL_OPTION_FIRECRACKER}"
          }, "img_mc_effect_chinesefirework_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_36.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_SPECIAL_OPTION_CABASA}"
          }, "img_mc_effect_sandbell_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_37.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_SPECIAL_OPTION_SNOWFLECK}"
          }, "img_mc_effect_snow_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_38.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_SPECIAL_OPTION_STAR}"
          }, "img_mc_effect_start_m"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_39.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_SPECIAL_OPTION_EYEBALL}"
          }, "img_mc_character_eyeball"],
          [{
            src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/goods_img/img_mc_item_40.png",
            width: 50,
            height: 50,
            alt: "%{BKY_NUWA_TEXT_SPECIAL_OPTION_GOLD}"
          }, "img_mc_character_gold"]
        ]
      },
      {
        "type": "field_number",
        "name": "input2",
        "value": 3,
        "min": 1,
        "precision": 1
      }
    ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_FACE_COLOR}",
      "tooltip": "",
      "helpUrl": ""
    },
    { // 上传图片
      "type": "other_function_camera",
      "width": 120,
      "message0": "%{BKY_NUWA_PHOTO}",
      "args0": [
        {
          "name": "input1",
          "type": "field_custom_media",
          "value": "",
          "mediaType": "photo",
          "width": 48,
          "height": 32,
          "alt": "*",
          "icon": ""+ baseUrl +"static/js/blockly/media/nuwa/custom_media_icon_photo.png",
          "flipRtl": false
        },
        {
          "type": "field_number",
          "name": "input2",
          "value": 3,
          "min": 1,
          "precision": 1
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_FACE_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_CUSTOM_PHOTO}",
      "helpUrl": ""
    },
    { //上传影片
      "type": "other_function_video",
      "message0": "%{BKY_NUWA_VIDEO}",
      "args0": [
        {
          "name": "input1",
          "type": "field_custom_media",
          "value": "",
          "mediaType": "video",
          "width": 48,
          "height": 32,
          "alt": "*",
          "icon": ""+ baseUrl +"static/js/blockly/media/nuwa/custom_media_icon_video.png",
          "flipRtl": false,
          "showText": true
        },
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_FACE_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_CUSTOM_VIDEO}",
      "helpUrl": ""
    },
    { //youtube
      "type": "function_video_youtube",
      "message0": "%{BKY_NUWA_VIDEO_YOUTUBE}",
      "args0": [
        {
          "name": "input1",
          "type": "field_custom_media",
          "value": "",
          "mediaType": "youtube",
          "width": 48,
          "height": 32,
          "alt": "*",
          "icon": ""+ process.env.BASE_URL +"static/js/blockly/media/nuwa/custom_media_icon_video.png",
          "flipRtl": false
        },
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_FACE_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_CUSTOM_VIDEO}",
      "helpUrl": ""
    },
  ]);
  //灯光目录
  Blockly.defineBlocksWithJsonArray([
    { // 全身发光
      "type": "light_all",
      "message0": "%{BKY_NUWA_LIGHT_BODY}",
      "args0": [
        {
          "type": "field_colour",
          "name": "input1",
          "colour": "#ff0000"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_LIGHT_COLOR}",
      "tooltip": "%{BKY_NUMWA_TOOLTIP_ROBOT_LIGHT}",
      "helpUrl": ""
    },
    { // 头部发光
      "type": "light_head",
      "message0": "%{BKY_NUWA_LIGHT_HEAD}",
      "args0": [
        {
          "type": "field_colour",
          "name": "input1",
          "colour": "#ff0000"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_LIGHT_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_ROBOT_LIGHT_HEAD}",
      "helpUrl": ""
    },
    { // 左手发光
      "type": "light_hand_left",
      "message0": "%{BKY_NUWA_LIGHT_LEFT_HAND}",
      "args0": [
        {
          "type": "field_colour",
          "name": "input1",
          "colour": "#ff0000"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_LIGHT_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_ROBOT_LIGHT_LEFT_HAND}",
      "helpUrl": ""
    },
    { // 右手发光
      "type": "light_hand_right",
      "message0": "%{BKY_NUWA_LIGHT_RIGHT_HAND}",
      "args0": [
        {
          "type": "field_colour",
          "name": "input1",
          "colour": "#ff0000"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_LIGHT_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_ROBOT_LIGHT_RIGHT_HAND}",
      "helpUrl": ""
    },
    { // 肚子发光
      "type": "light_belly",
      "message0": "%{BKY_NUWA_LIGHT_TUMMY}",
      "args0": [
        {
          "type": "field_colour",
          "name": "input1",
          "colour": "#ff0000"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_LIGHT_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_ROBOT_LIGHT_TUMMY}",
      "helpUrl": ""
    },
    {//发光
      "type": "nuwa_light",
      "message0": "%{BKY_NUWA_LIGHT}",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "input1",
          "options": [
            [
              "%{BKY_NUWA_TEXT_LIGHT_POSITION_0}",
              "0"
            ],
            [
              "%{BKY_NUWA_TEXT_LIGHT_POSITION_1}",
              "1"
            ],
            [
              "%{BKY_NUWA_TEXT_LIGHT_POSITION_3}",
              "3"
            ],
            [
              "%{BKY_NUWA_TEXT_LIGHT_POSITION_4}",
              "4"
            ],
            [
              "%{BKY_NUWA_TEXT_LIGHT_POSITION_2}",
              "2"
            ]
          ]
        },
        {
          "type": "input_value",
          "name": "input2"
        }
      ],
      "inputsInline": false,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_LIGHT_COLOR}",
      "tooltip": "",
      "helpUrl": ""
    }
  ]);
  //声音目录
  Blockly.defineBlocksWithJsonArray([
    { // 播放语音
      "type": "sound_say",
      "message0": "%{BKY_NUWA_VOICE_TTS}",
      "args0": [
        {
          "type": "field_input",
          "name": "input1",
          "text": ""
        },
        // {
        //     "type": "field_dropdown",
        //     "name": "input2",
        //     "value": "0",
        //     "options": [
        //         ["%{BKY_NUWA_TEXT_RANDOM_MOTION_OPTION_0}", "0"],
        //         ["%{BKY_NUWA_TEXT_RANDOM_MOTION_OPTION_1}", "1"]
        //     ]
        // }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_SOUND_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_VOICE_TTS}",
      "helpUrl": ""
    },
    {
      "type": "sound_say2",
      "message0": "%{BKY_NUWA_VOICE_TTS}",
      "args0": [
        {
          "type": "input_value",
          "name": "input1",
          "check": ["String", "Number"]
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_SOUND_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_VOICE_TTS}",
      "helpUrl": ""
    },
    { // 动物声
      "type": "sound_animal",
      "message0": "%{BKY_NUWA_VOICE_ANIMAL}",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "input1",
          "bg": "%{BKY_NUWA_CATEGORY_SOUND_COLOR}",
          "options": [
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/animal_sound/img_mc_animal_01.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_ANIMAL_ELEPHANT}"
            }, "cp_soundcube_animal_elephant"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/animal_sound/img_mc_animal_02.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_ANIMAL_SHEEP}"
            }, "cp_soundcube_animal_sheep"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/animal_sound/img_mc_animal_03.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_ANIMAL_MONKEY}"
            }, "cp_soundcube_animal_monkey"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/animal_sound/img_mc_animal_04.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_ANIMAL_HORSE}"
            }, "cp_soundcube_animal_hourse"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/animal_sound/img_mc_animal_05.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_ANIMAL_PUPPY}"
            }, "cp_soundcube_animal_dog"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/animal_sound/img_mc_animal_06.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_ANIMAL_COW}"
            }, "cp_soundcube_animal_cow"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/animal_sound/img_mc_animal_07.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_ANIMAL_CHICKEN}"
            }, "cp_soundcube_animal_chicken"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/animal_sound/img_mc_animal_08.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_ANIMAL_KITTEN}"
            }, "cp_soundcube_animal_cat"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/animal_sound/img_mc_animal_09.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_ANIMAL_BIRDIE}"
            }, "cp_soundcube_animal_bird"]
          ]
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_SOUND_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_VOICE_ANIMAL}",
      "helpUrl": ""
    },
    { // 音阶
      "type": "sound_scale",
      "message0": "%{BKY_NUWA_VOICE_GAMUT}",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "input1",
          "bg": "%{BKY_NUWA_CATEGORY_SOUND_COLOR}",
          "options": [
            ["Do", "cp_musiccube_note_do_full"],
            ["Re", "cp_musiccube_note_re_full"],
            ["Mi", "cp_musiccube_note_mi_full"],
            ["Fa", "cp_musiccube_note_fa_full"],
            ["Sol", "cp_musiccube_note_so_full"],
            ["La", "cp_musiccube_note_la_full"],
            ["Si", "cp_musiccube_note_ci_full"],
            ["Do'", "cp_musiccube_note_do_half"]
          ]
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_SOUND_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_VOICE_NUWA_ANIMAL_SCALE}",
      "helpUrl": ""
    },
    { // 特殊音效
      "type": "sound_effect",
      "message0": "%{BKY_NUWA_VOICE_EFFECT}",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "input1",
          "bg": "%{BKY_NUWA_CATEGORY_SOUND_COLOR}",
          "options": [
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_1_cheer.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_APPLAUSE}"
            }, "cp_level_applause"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_2_debut1.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_DEBUT_1}"
            }, "cp_level_onstage"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_3_debut2.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_DEBUT_2}"
            }, "cp_level_success"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_4_bubbles.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_BUBBLES}"
            }, "cp_level_enter"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_5_item1.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_TAKE_OUT_TOOL_1}"
            }, "cp_level_magictool_1"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_6_item2.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_TAKE_OUT_TOOL_2}"
            }, "cp_level_magictool_2"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_7_item3.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_TAKE_OUT_TOOL_3}"
            }, "cp_level_magictool_3"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_8_item4.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_TAKE_OUT_TOOL_4}"
            }, "cp_level_magictool_4"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_9_firework.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_FIRECRACHER}"
            }, "cp_level_chinesefirework"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_10_funny.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_FUNNY}"
            }, "cp_funnysfx1"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_11_triangle.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_TRIANGLE}"
            }, "cp_musiccube_triangle"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_12_bell.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_BELL}"
            }, "cp_musiccube_xmasbell"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_13_sand bell.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_CABASA}"
            }, "cp_musiccube_sandbell2"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_14_cool.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_COOL}"
            }, "cp_soundcube_effect_yocheckout"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_15_surprise.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_SURPRISE}"
            }, "cp_soundcube_effect_wow"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_16_laughter1.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_LAUGHTER_1}"
            }, "cp_soundcube_effect_laughter1"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_17_laughter2.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_LAUGHTER_2}"
            }, "cp_soundcube_effect_laughter2"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_18_hi.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_HELLO}"
            }, "cp_soundcube_effect_hello"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_19_doorbell.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_DOOR_BELL}"
            }, "cp_soundcube_effect_doorbell"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_20_screaming.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_SCREAM}"
            }, "cp_soundcube_effect_cheering"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_21_pay.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_CASHIER}"
            }, "cp_soundcube_effect_cashier"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_22_clap.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_CLAPPING}"
            }, "cp_soundcube_effect_calpping"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_23.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_BURP}"
            }, "cp_level_hiccup"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_24.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_FIGHT}"
            }, "cp_level_fight"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_25.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_MONSTER}"
            }, "cp_level_chinesemonster"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_26.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_FART}"
            }, "cp_level_fart"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_27.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_YO}"
            }, "cp_level_fight_move_1"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/effect_sound/img_mc_sound_28.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EFFECT_OPTION_WOW}"
            }, "cp_level_fight_move_3"]
          ]
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_SOUND_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_SPECIAL_EFFECT}",
      "helpUrl": ""
    },
    { // 背景音乐
      "type": "sound_background",
      "message0": "%{BKY_NUWA_VOICE_BG}",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "input1",
          "bg": "%{BKY_NUWA_CATEGORY_SOUND_COLOR}",
          "options": [
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/bgm_sound/img_mc_bgm_1_convenien.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_SOUND_OPTION_SHOP}"
            }, "cp_bgm_level02_shop"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/bgm_sound/img_mc_bgm_2_game.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_SOUND_OPTION_GAME}"
            }, "cp_bgm_ingame"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/bgm_sound/img_mc_bgm_3_appearance1.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_SOUND_OPTION_DEBUT1}"
            }, "cp_source_bgm_1"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/bgm_sound/img_mc_bgm_4_appearance2.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_SOUND_OPTION_DEBUT2}"
            }, "cp_source_bgm_2"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/bgm_sound/img_mc_bgm_5_christmas1.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_SOUND_OPTION_XMAX}"
            }, "cp_level_music_together"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/bgm_sound/img_mc_bgm_6_funny.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_SOUND_OPTION_FUNNY}"
            }, "cp_source_bgm_3"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/bgm_sound/img_mc_bgm_7_teatime.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_SOUND_OPTION_EZ_AFTER}"
            }, "cp_musiccube_picnic"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/bgm_sound/img_mc_bgm_8_party.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_SOUND_OPTION_DANCE}"
            }, "cp_musiccube_princessparty"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/bgm_sound/img_mc_bgm_9_waltz.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_SOUND_OPTION_WALTZ}"
            }, "cp_musiccube_waltz"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/bgm_sound/img_mc_bgm_10_celebrate.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_SOUND_OPTION_CELEBRATION}"
            }, "cp_musiccube_celebration"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/bgm_sound/img_mc_bgm_11_christmas2.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_SOUND_OPTION_PLAYFUL_XMAX}"
            }, "cp_musiccube_xmassong01_benzo"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/bgm_sound/img_mc_bgm_12_christmas3.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_SOUND_OPTION_XMAX_PRELUDE}"
            }, "cp_musiccube_xmassong01_melody"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/bgm_sound/img_mc_bgm_13_covertly.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_SOUND_OPTION_SNEAK}"
            }, "cp_musiccube_sneak"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/bgm_sound/img_mc_bgm_14_lunch.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_SOUND_OPTION_LUNCHEON}"
            }, "cp_musiccube_energetic"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/bgm_sound/img_mc_bgm_15_walking.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_SOUND_OPTION_STROLLING}"
            }, "cp_musiccube_naughty"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/bgm_sound/img_mc_bgm_16_trick.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_SOUND_OPTION_CUNNING}"
            }, "cp_musiccube_smartkid"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/bgm_sound/img_mc_bgm_17_daydream.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_SOUND_OPTION_DAYDREAM}"
            }, "cp_musiccube_daydream"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/bgm_sound/img_mc_bgm_18_outing.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_SOUND_OPTION_WALK}"
            }, "cp_musiccube_dancemusic"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/bgm_sound/img_mc_bgm_19_competition.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_SOUND_OPTION_SPORT}"
            }, "cp_sport_music"]
          ]
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_SOUND_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_VOICE_BG_MUSIC}",
      "helpUrl": ""
    },
    { //上传音档/录音
      "type": "sound_record",
      "message0": "%{BKY_NUWA_AUDIO}",
      "args0": [
        {
          "name": "input1",
          "type": "field_custom_media",
          "value": "",
          "mediaType": "audio",
          "width": 48,
          "height": 32,
          "alt": "*",
          "icon": ""+ baseUrl +"static/js/blockly/media/nuwa/custom_media_icon_audio.png",
          "flipRtl": false,
          "showText": true
        },
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_SOUND_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_CUSTOM_AUDIO}",
      "helpUrl": ""
    }
  ]);
  //主题表演目录
  Blockly.defineBlocksWithJsonArray([
    { // 动态贴图
      "type": "motion_general",
      "message0": "%{BKY_NUWA_DAILY_REACTION}",
      "args0":[
        {
          "type": "field_dropdown",
          "name": "input1",
          "bg": "%{BKY_NUWA_CATEGORY_ANIMATION_COLOR}",
          "options": [
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/dymic_images/img_mc_stickers_01.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_DYMIC_OPTION_CORRECT}"
            }, "001_P1_Correct"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/dymic_images/img_mc_stickers_02.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_DYMIC_OPTION_WRONG}"
            }, "001_P1_Wrong"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/dymic_images/img_mc_stickers_03.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_DYMIC_OPTION_NEW_YEAR}"
            }, "000_J3_HappyNewYear"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/dymic_images/img_mc_stickers_04.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_DYMIC_OPTION_CHRISTMAS}"
            }, "001_J3_Christmas"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/dymic_images/img_mc_stickers_05.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_DYMIC_OPTION_WEALTHY}"
            }, "001_J2_Newyear"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/dymic_images/img_mc_stickers_06.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_DYMIC_OPTION_VALENTINE}"
            }, "001_J3_VDay"]
          ]
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_ANIMATION_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_DAILY_REACTION}",
      "helpUrl": ""
    },
    { // 情绪反应
      "type": "motion_emotion",
      "message0": "%{BKY_NUWA_EMOTION_REACTION}",
      "args0":[
        {
          "type": "field_dropdown",
          "name": "input1",
          "bg": "%{BKY_NUWA_CATEGORY_ANIMATION_COLOR}",
          "options":[
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/expression_emition/img_mc_emotin_1.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EMOTION_OPTION_JOY_1}"
            }, "001_J1_Joyful"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/expression_emition/img_mc_emotin_2.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EMOTION_OPTION_JOY_2}"
            }, "001_J1_Smile"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/expression_emition/img_mc_emotin_3.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EMOTION_OPTION_JOY_3}"
            }, "001_J3_High"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/expression_emition/img_mc_emotin_4.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EMOTION_OPTION_SAD_1}"
            }, "001_S3_Sad"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/expression_emition/img_mc_emotin_5.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EMOTION_OPTION_SAD_2}"
            }, "001_S1_Sad"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/expression_emition/img_mc_emotin_6.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EMOTION_OPTION_SAD_3}"
            }, "001_S1_Sorrowful"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/expression_emition/img_mc_emotin_7.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EMOTION_OPTION_MAD_1}"
            }, "001_A1_Mad"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/expression_emition/img_mc_emotin_8.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EMOTION_OPTION_MAD_2}"
            }, "001_A1_Exert"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/expression_emition/img_mc_emotin_9.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EMOTION_OPTION_MAD_3}"
            }, "001_A3_Fury"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/expression_emition/img_mc_emotin_10.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EMOTION_OPTION_FEAR_1}"
            }, "001_F1_Fear"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/expression_emition/img_mc_emotin_11.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EMOTION_OPTION_FEAR_2}"
            }, "001_F2_Afraid"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/expression_emition/img_mc_emotin_12.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EMOTION_OPTION_AFFECTIONNATE}"
            }, "001_J3_WBPetted"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/expression_emition/img_mc_emotin_13.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EMOTION_OPTION_HELLO}"
            }, "001_J2_WAttention"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/expression_emition/img_mc_emotin_14.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EMOTION_OPTION_SCRATCHING}"
            }, "001_P5_Bathe_D"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/expression_emition/img_mc_emotin_15.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_EMOTION_OPTION_FART}"
            }, "001_D2_Disgusted"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/expression_emition/img_mc_emotin_16.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_MONSTER_OPTION_PENDULUM}"
            }, "001_DA_Press"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/expression_emition/img_mc_emotin_17.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_MONSTER_OPTION_DISDAIN}"
            }, "001_A4_IOTOn"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/expression_emition/img_mc_emotin_18.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_MONSTER_OPTION_SHOCKED}"
            }, "001_E1_Shocked"],
          ]
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_ANIMATION_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_EMOTION_REACTION}",
      "helpUrl": ""
    },
    { // 趣味表演
      "type": "motion_naughty_2",
      "message0": "%{BKY_NUWA_MAKE_FACE}",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "input1",
          "bg": "%{BKY_NUWA_CATEGORY_ANIMATION_COLOR}",
          "options": [
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/funny_image/img_mc_funny_01.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_MONSTER_OPTION_FART}"
            }, "001_E1_Fart"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/funny_image/img_mc_funny_02.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_MONSTER_OPTION_FACE1}"
            }, "001_A2_Grimace"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/funny_image/img_mc_funny_03.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_MONSTER_OPTION_FACE2}"
            }, "001_J1_Grimace"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/funny_image/img_mc_funny_04.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_MONSTER_OPTION_WHISTLE}"
            }, "001_J1_Satisfied"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/funny_image/img_mc_funny_05.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_MONSTER_OPTION_BOW}"
            }, "001_J4_IOTOn"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/funny_image/img_mc_funny_06.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_MONSTER_OPTION_CHEER}"
            }, "001_J2_GMFive_B1"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/funny_image/img_mc_funny_07.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_MONSTER_OPTION_HIT}"
            }, "001_J2_GMFive_B2"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/funny_image/img_mc_funny_08.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_MONSTER_OPTION_SNIVEL}"
            }, "001_P5_Snivel"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/funny_image/img_mc_funny_09.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_MONSTER_OPTION_SNEEZE}"
            }, "001_P5_Sneeze"],
            [{
              src: ""+ baseUrl +"static/js/blockly/media/nuwa/select_options/funny_image/img_mc_funny_10.png",
              width: 50,
              height: 50,
              alt: "%{BKY_NUWA_TEXT_MONSTER_OPTION_FIGHT}"
            }, "001_FI_Fight"]
          ]
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_ANIMATION_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_MAKE_FACE}",
      "helpUrl": ""
    },
    { // 节日
      "type": "motion_festival",
      "message0": "%{BKY_NUWA_FESTIVAL}",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "input1",
          "options": [
            ["%{BKY_NUWA_TEXT_DYMIC_OPTION_NEW_YEAR}", "000_J3_HappyNewYear"],
            ["%{BKY_NUWA_TEXT_DYMIC_OPTION_CHRISTMAS}", "001_J3_Christmas"],
            ["%{BKY_NUWA_TEXT_DYMIC_OPTION_WEALTHY}", "001_J2_Newyear"],
            ["%{BKY_NUWA_TEXT_DYMIC_OPTION_VALENTINE}", "001_J3_VDay"]
          ]
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_ANIMATION_COLOR}",
      "tooltip": "",
      "helpUrl": ""
    },
  ]);
  //数学目录
  Blockly.defineBlocksWithJsonArray([
    { // 四舍五入
      "type": "nuwa_math_round",
      "message0": "%{BKY_NUWA_MATH_ROUND}",
      "args0": [
        {
          "type": "input_value",
          "name": "number",
          "check": "Number"
        },
        {
          "type": "field_number",
          "name": "precision",
          "value": 0,
          "min": 0
        }
      ],
      "inputsInline": true,
      "output": "Number",
      "colour": "%{BKY_NUWA_CATEGORY_MATH_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_MATH_ROUND}",
      "helpUrl": ""
    },
  ]);
  //MQTT连线目录
  Blockly.defineBlocksWithJsonArray([
    {//MQTT连线
      "type": "mqtt_connect",
      "message0": "%{BKY_NUWA_MQTT_CONNECT}",
      "args0": [
        {
          "type": "input_value",
          "name": "input1",
          "check": "String"
        },
        {
          "type": "input_value",
          "name": "input2",
          "check": "String"
        },
        {
          "type": "input_value",
          "name": "input3",
          "check": "String"
        }
      ],
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MQTT_COLOUR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_MQTT_CONNECT}",
      "helpUrl": ""
    },
    {
      "type": "mqtt_publish",
      "message0": "%{BKY_NUWA_MQTT_PUBLISH}",
      "args0": [
        {
          "type": "input_value",
          "name": "input1",
          "check": "String"
        },
        {
          "type": "input_value",
          "name": "input2",
          "check": "String"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MQTT_COLOUR}",
      "tooltip": "%{NUWA_TOOLTIP_MQTT_PUBLISH}",
      "helpUrl": ""
    },
    {
      "type": "mqtt_subscribe_message",
      "message0": "%{BKY_NUWA_MQTT_SUBSCRIBE_MESSAGE}",
      "args0": [
        {
          "type": "input_value",
          "name": "input1",
          "check": "String"
        },
        {
          "type": "input_dummy"
        },
        {
          "type": "input_statement",
          "name": "input2"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MQTT_COLOUR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_MQTT_SUBSCRIBE_MESSAGE}",
      "helpUrl": ""
    },
    {
      "type": "mqtt_message_text",
      "message0": "%{BKY_NUWA_MQTT_MESSAGE_TEXT}",
      "output": "String",
      "colour": "%{BKY_NUWA_CATEGORY_MQTT_COLOUR}",
      "tooltip": "",
      "helpUrl": ""
    },
  ]);

  //Aiot
  Blockly.defineBlocksWithJsonArray([
    {
      "type": "aiot_connect",
      "message0": "连接 Motoduino ESP8266 WiFi 開發板 %1 %2 请输入device id %3 请输入用户名 %4 请输入密码 %5 %6",
      "args0": [
          {
            "type": "input_dummy"
          },
          {
            "type": "input_dummy"
          },
          {
            "type": "input_value",
            "name": "input1"
          },
          {
            "type": "input_value",
            "name": "input2"
          },
          {
            "type": "input_value",
            "name": "input3"
          },
          {
            "type": "input_dummy"
          }
      ],
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_AIOT_COLOUR}",
      "tooltip": "",
      "helpUrl": ""
    },
    {
      "type": "buzzer_iot",
      "message0": "向蜂鳴器传送 頻率: %1 和 聲響時間: %2",
      "args0": [
        {
          "type": "field_input",
          "name": "input1",
          "text": "525"
        },
        {
          "type": "field_input",
          "name": "input2",
          "text": "500"
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_AIOT_COLOUR}",
      "tooltip": "",
      "helpUrl": ""
    },
    {
      "type": "relay_iot",
      "message0": "%1 繼電器",
      "args0": [
        {
          "type": "field_dropdown",
          "name": "option1",
          "options": [
            [
              "打开",
              "on"
            ],
            [
              "关闭",
              "off"
            ]
          ]
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_AIOT_COLOUR}",
      "tooltip": "",
      "helpUrl": ""
    },
    {
      "type": "light_iot",
      "message0": "当接收到来自 光源感測器 数据时 %1 %2",
      "args0": [
        {
          "type": "input_dummy"
        },
        {
          "type": "input_statement",
          "name": "statement"
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_AIOT_COLOUR}",
      "tooltip": "",
      "helpUrl": ""
    },
    {
      "type": "ult_iot",
      "message0": "当接收到来自 超音波感測器 数据时 %1 %2",
      "args0": [
        {
          "type": "input_dummy"
        },
        {
          "type": "input_statement",
          "name": "statement"
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_AIOT_COLOUR}",
      "tooltip": "",
      "helpUrl": ""
    },
    {
    "type": "environment_iot",
    "message0": "当接收到环境感测器(PM,溫濕度)的 %1 数据时 %2 %3",
    "args0": [
      {
        "type": "field_dropdown",
        "name": "option1",
        "options": [
            [
              "Pm1.0",
              "pm10"
            ],
            [
              "pm2.5",
              "pm25"
            ],
            [
              "pm10",
              "pm100"
            ],
            [
              "溫度",
              "t"
            ],
            [
              "濕度",
              "h"
            ]
          ]
        },
        {
          "type": "input_dummy"
        },
        {
          "type": "input_statement",
          "name": "statement"
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_AIOT_COLOUR}",
      "tooltip": "",
      "helpUrl": ""
    },
    {
      "type": "aiot_publish",
      "message0": "%{BKY_NUWA_MQTT_PUBLISH}",
      "args0": [
        {
          "type": "input_value",
          "name": "input1",
          "check": "String"
        },
        {
          "type": "input_value",
          "name": "input2",
          "check": "String"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_AIOT_COLOUR}",
      "tooltip": "%{NUWA_TOOLTIP_MQTT_PUBLISH}",
      "helpUrl": ""
    },
    {
      "type": "aiot_subscribe_message",
      "message0": "%{BKY_NUWA_MQTT_SUBSCRIBE_MESSAGE}",
      "args0": [
        {
          "type": "input_value",
          "name": "input1",
          "check": "String"
        },
        {
          "type": "input_dummy"
        },
        {
          "type": "input_statement",
          "name": "input2"
        }
      ],
      "inputsInline": true,
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_AIOT_COLOUR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_MQTT_SUBSCRIBE_MESSAGE}",
      "helpUrl": ""
    },
    {
      "type": "aiot_message_text",
      "message0": "%{BKY_NUWA_MQTT_MESSAGE_TEXT}",
      "output": "String",
      "colour": "%{BKY_NUWA_CATEGORY_AIOT_COLOUR}",
      "tooltip": "",
      "helpUrl": ""
    }
  ]);
  //素材库块
  function getAddFromMaterialibOption(materialType, label){
    return [{
      src: baseUrl + "static/js/blockly/media/nuwa/gra-addnickname.svg",
      width: 50,
      height: 50,
      alt: (label ? label: "%{BKY_NUWA_TEXT_ADD_FROM_MATERIALLIB}")
    }, function (field) {
      if(!field){
        return "add_from_online";
      }
      if(document.createEvent) {
        var event = document.createEvent("CustomEvent");
        event.initCustomEvent("openMaterialLib", true, true);
        event.materialType = materialType;
        document.body.dispatchEvent(event);
      }
      Blockly.WidgetDiv.hideIfOwner(field);
    }]
  }
  function getDeleteMaterialoption(){
    return [
      `<svg width="18" height="18" fill="#666666;"><use xlink:href="#material-list-icon-delete"></use></svg>`, 
      function(field, option){
        Blockly.deleteProjectMaterial({projectMaterialId: option[0].projectMaterialId, type: (option[0].type || '')}, () => {
          Blockly.WidgetDiv.hide();
          let options = field.getOptions();
          let fieldValue = field.getValue();
          let currentOption = options.find(item => (typeof item[1] === "function"?item[1](): item[1]) === fieldValue);
          if(currentOption && currentOption[1] === option[1]){
            field.setValue("");
            let sourceBlock = field.sourceBlock_;
            if(sourceBlock){
              let input2 = sourceBlock.getField("input2");
              input2 && input2.setValue("");
            }
          }
        });
      }
    ]
  }
  function getMaterialTitle(material){
    const langCode = Cookies.get("langCode");
    if(material.metadata && material.metadata.i18n){
      let langItem = material.metadata.i18n.find(item => item.langCode === langCode);
      if(langItem){
        return langItem.name || langItem.description;
      }
    }
    if(material.metadata.title){
      return material.metadata.title;
    }
    return material.index || "";
  }
  Blockly.defineBlocksWithJsonArray([
    {//动态表情
      "type": "material_lib_role",
      "message0": "%{BKY_NUWA_MATERIALLIB_ROLE_EMOTION}",
      "args0": [
        {
          "type": "field_dynamic_dropdown",
          "name": "input1",
          "placeholder": "%{BKY_NUWA_TEXT_SELECT_PROJECT_MATERIAL}",
          "options": function(){
            let optionAdd = getAddFromMaterialibOption("role");
            let materials = Blockly.getNuwaMaterialsByType("role");
            if(materials.length === 0){
              return [optionAdd,
                [
                  "%{BKY_NUWA_TEXT_ADD_ROLE_MATERIAL}",
                  "nuwa_menu_small"
                ]
              ];
            } else {
              return [
                optionAdd, 
                ...materials.map(item => {
                  return [{
                    src: utils.formatUrlWithToken$(item.screenshot),
                    width: 50,
                    height: 50,
                    alt: getMaterialTitle(item),
                    projectMaterialId: item.projectMaterialId
                  }, field => {
                    if(!field){
                      return item.index;
                    }
                    field.setValue(item.index); 
                    Blockly.WidgetDiv.hideIfOwner(field);
                    Blockly.Events.setGroup(false);
                    let sourceBlock = field.sourceBlock_;
                    if(sourceBlock){
                      let input2 = sourceBlock.getField("input2");
                      input2 && input2.setValue("");
                    }
                  }, getDeleteMaterialoption()]
                })
              ]
            }
          }
        },
        {
          "type": "field_dynamic_dropdown",
          "name": "input2",
          "placeholder": "%{BKY_NUWA_TEXT_SELECT_EMOTION}",
          "options": function(field){
            let noDataOption = ["%{BKY_NUWA_TEXT_SELECT_PROJECT_MATERIAL}", "nuwa_menu_small"];
            return new Promise(resolve => {
              setTimeout(() => {
                let sourceBlock = field.sourceBlock_;
                if(sourceBlock){
                  let input1Value = sourceBlock.getFieldValue("input1");
                  let emotions = Blockly.getRoleEmotions(input1Value);
                  if(emotions.length > 0){
                    let emotionOptions = emotions.map(item => {
                      return [
                        {
                          src: utils.formatUrlWithToken$(item.url),
                          width: 50,
                          height: 50,
                          alt: item.metadata.emotion
                        }, item.metadata.emotion
                      ]
                    });
                    resolve(emotionOptions);
                  } else {
                    resolve([noDataOption]);
                  }
                } else {
                  resolve([noDataOption]);
                }
              }, 0);
            })
          }
        },
        {
          "type": "field_number",
          "name": "input3",
          "value": 0,
          "min": 0,
          "precision": 1
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MATERIALLIB_COLOUR}",
      "tooltip": "",
      "helpUrl": ""
    },
    {//图片
      "type": "material_lib_image",
      "message0": "%{BKY_NUWA_MATERIALLIB_PICTURE}",
      "args0": [
        {
          "type": "field_dynamic_dropdown",
          "name": "input1",
          "placeholder": "%{BKY_NUWA_TEXT_SELECT_PROJECT_MATERIAL}",
          "options": function(){  
            let optionAdd = getAddFromMaterialibOption("image");
            let materials = Blockly.getNuwaMaterialsByType("image");
            if(materials.length === 0){
              return [optionAdd,
                [
                  "%{BKY_NUWA_TEXT_ADD_IMG_MATERIAL}",
                  "nuwa_menu_small"
                ]
              ];
            } else {
              return [
                optionAdd, 
                ...materials.map(item => {
                  return [{
                    src: utils.formatUrlWithToken$(item.screenshot),
                    width: 50,
                    height: 50,
                    alt: getMaterialTitle(item),
                    projectMaterialId: item.projectMaterialId
                  }, item.index + "." + item.ext, getDeleteMaterialoption()]
                })
              ]
            }
          }
        },
        {
          "type": "field_number",
          "name": "input2",
          "value": 3,
          "min": 1,
          "precision": 1
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MATERIALLIB_COLOUR}",
      "tooltip": "",
      "helpUrl": ""
    },
    {//影片（情绪表现）
      "type": "material_lib_video",
      "message0": "%{BKY_NUWA_MATERIALLIB_VIDEO}",
      "args0": [
        {
          "type": "field_dynamic_dropdown",
          "name": "input1",
          "placeholder": "%{BKY_NUWA_TEXT_SELECT_PROJECT_MATERIAL}",
          "options": function(){
            let optionAdd = getAddFromMaterialibOption("video");
            let materials = Blockly.getNuwaMaterialsByType("video");
            if(materials.length === 0){
              return [optionAdd,
                [
                  "%{BKY_NUWA_TEXT_ADD_VIDEO_MATERIAL}",
                  "nuwa_menu_small"
                ]
              ];
            } else {
              return [
                optionAdd, 
                ...materials.map(item => {
                  return [{
                    src: utils.formatUrlWithToken$(item.screenshot),
                    width: 50,
                    height: 50,
                    alt: getMaterialTitle(item),
                    projectMaterialId: item.projectMaterialId
                  },field => {
                    if(!field){
                      return item.index + "." + item.ext;
                    }
                    field.setValue(item.index + "." + item.ext); 
                    Blockly.WidgetDiv.hideIfOwner(field);
                    Blockly.Events.setGroup(false);
                    let duration = Math.ceil(item.metadata.duration / 100) / 10;
                    let sourceBlock = field.sourceBlock_;
                    console.log(duration)
                    if(sourceBlock){
                      let input2 = sourceBlock.getField("input2");
                      input2 && input2.setValue(duration);
                    }
                  }, getDeleteMaterialoption()]
                })
              ]
            }
          }
        },
        {
          "type": "field_number",
          "name": "input2",
          "value": 3,
          "min": 1,
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MATERIALLIB_COLOUR}",
      "tooltip": "",
      "helpUrl": ""
    },
    {//声音
      "type": "material_lib_audio",
      "message0": "%{BKY_NUWA_MATERIALLIB_AUDIO}",
      "args0": [
        {
          "type": "field_dynamic_dropdown",
          "name": "input1",
          "placeholder": "%{BKY_NUWA_TEXT_SELECT_PROJECT_MATERIAL}",
          "options": function(){
            let optionAdd = getAddFromMaterialibOption("audio");
            let materials = Blockly.getNuwaMaterialsByType("audio");
            if(materials.length === 0){
              return [optionAdd,
                [
                  "%{BKY_NUWA_TEXT_ADD_AUDIO_MATERIAL}",
                  "nuwa_menu_small"
                ]
              ];
            } else {
              return [
                optionAdd, 
                ...materials.map(item => {
                  return [{
                    src: "#material-type-audio",
                    width: 50,
                    height: 50,
                    style: {
                      fill: "#444444",
                      transform: "scale(0.7)"
                    },
                    alt: getMaterialTitle(item),
                    projectMaterialId: item.projectMaterialId
                  }, item.index + "." + item.ext, getDeleteMaterialoption()]
                })
              ]
            }
          }
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MATERIALLIB_COLOUR}",
      "tooltip": "",
      "helpUrl": ""
    },
    {//动作
      "type": "material_lib_motion",
      "message0": "%{BKY_NUWA_MATERIALLIB_MOTION}",
      "args0": [
        {
          "type": "field_dynamic_dropdown",
          "name": "input1",
          "placeholder": "%{BKY_NUWA_TEXT_SELECT_PROJECT_MATERIAL}",
          "options": function(){
            let optionAdd = getAddFromMaterialibOption("motion");
            let materials = Blockly.getNuwaMaterialsByType("motion");
            if(materials.length === 0){
              return [optionAdd,
                [
                  "%{BKY_NUWA_TEXT_ADD_MOTION_MATERIAL}",
                  "nuwa_menu_small"
                ]
              ];
            } else {
              return [
                optionAdd, 
                ...materials.map(item => {
                  return [{
                    src: "#material-type-motion",
                    width: 50,
                    height: 50,
                    alt: getMaterialTitle(item),
                    style: {
                      fill: "#444444",
                      transform: "scale(0.7)"
                    },
                    projectMaterialId: item.projectMaterialId
                  }, item.index + "." + item.ext, getDeleteMaterialoption()]
                })
              ]
            }
          }
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_CATEGORY_MATERIALLIB_COLOUR}",
      "tooltip": "",
      "helpUrl": ""
    },
    {//内容档
    "type": "material_lib_content",
    "message0": "%{BKY_NUWA_MATERIALLIB_CONTENT}",
    "args0": [
      {
        "type": "field_dynamic_dropdown",
        "name": "input1",
        "placeholder": "%{BKY_NUWA_TEXT_SELECT_PROJECT_MATERIAL}",
        "options": function(){
          let optionAdd = getAddFromMaterialibOption("content");
          let materials = Blockly.getNuwaMaterialsByType("content");
          if(materials.length === 0){
            return [optionAdd,
              [
                "%{BKY_NUWA_TEXT_ADD_CONTENT_MATERIAL}",
                "nuwa_menu_small"
              ]
            ];
          } else {
            return [
              optionAdd, 
              ...materials.map(item => {
                return [{
                  src: utils.formatUrlWithToken$(item.screenshot),
                  width: 50,
                  height: 50,
                  alt: getMaterialTitle(item),
                  // style: {
                  //   // fill: "#444444",
                  //   transform: "scale(0.9)"
                  // },
                  projectMaterialId: item.projectMaterialId
                }, item.index + "." + item.ext, getDeleteMaterialoption()]
              })
            ]
          }
        }
      }
    ],
    "previousStatement": null,
    "nextStatement": null,
    "colour": "%{BKY_NUWA_CATEGORY_MATERIALLIB_COLOUR}",
    "tooltip": "",
    "helpUrl": ""
  },{//舞蹈编辑器
    "type": "material_lib_dance",
    "message0": "%{BKY_NUWA_MATERIALLIB_DANCE}",
    "args0": [
      {
        "type": "field_dynamic_dropdown",
        "name": "input1",
        "placeholder": "%{BKY_NUWA_TEXT_SELECT_DANCE_PROJECT}",
        "options": function(){
          let optionAdd = getAddFromMaterialibOption("dance", "%{BKY_NUWA_TEXT_ADD_FROM_ROBOT}");
          let materials = Blockly.getNuwaMaterialsByType("motion", false);
          if(materials.length === 0){
            return [optionAdd,
              [
                "%{BKY_NUWA_TEXT_ADD_DANCE_MATERIAL}",
                "nuwa_menu_small"
              ]
            ];
          } else {
            return [
              optionAdd, 
              ...materials.map(item => {
                return [{
                  src: utils.formatUrlWithToken$(item.screenshot),
                  width: 50,
                  height: 50,
                  alt: getMaterialTitle(item),
                  projectMaterialId: item.projectMaterialId
                }, item.index + "." + item.ext, getDeleteMaterialoption()]
              })
            ]
          }
        }
      }
    ],
    "previousStatement": null,
    "nextStatement": null,
    "colour": "%{BKY_NUWA_CATEGORY_MATERIALLIB_COLOUR}",
    "tooltip": "",
    "helpUrl": ""
  }  
  ]);
  function getAiObjectBlockOptions(){
    let addLabel = '%{BKY_NUWA_ADD_AIOBJECT_MATERIAL}'  
    let optionAdd = getAddAiObjectOption("aiObject", addLabel);
    let materials = Blockly.getNuwaMaterialsByType("aiObject");
    if(materials.length === 0){
      return [optionAdd,
        [
          "%{BKY_NUWA_TEXT_ADD_AIOBJECT_MATERIAL}",
          "nuwa_menu_small"
        ]
      ];
    } else {
      return [
        optionAdd, 
        ...materials.map(item => {
          return [{
            width: 1,
            height: 32,
            src: '',
            alt: getMaterialTitle(item),
            projectMaterialId: item.projectMaterialId,
            type: 'aiObject'
          }, `${item.metadata.itemId}`, getDeleteMaterialoption()]
        })
      ]
    }
  }
  function getAddAiObjectOption(materialType, label){
    return [{
      src: baseUrl + "static/js/blockly/media/nuwa/gra-addnickname.svg",
      width: 20,
      height: 20,
      alt: (label ? label: "%{BKY_NUWA_TEXT_ADD_FROM_MATERIALLIB}")
    }, function (field) {
      if(!field){
        return "add_from_online";
      }
      if(document.createEvent) {
        var event = document.createEvent("CustomEvent");
        event.initCustomEvent("openMaterialLib", true, true);
        event.materialType = materialType;
        document.body.dispatchEvent(event);
      }
      Blockly.WidgetDiv.hideIfOwner(field);
    }]
  }
  Blockly.defineBlocksWithJsonArray([
    {//辨識任何物品
      "type": "other_function_recognize",
      "message0": "%{BKY_NUWA_RECOGNIZE}",
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_RECOGNIZE_BLOCK_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_RECOGNIZE}",
      "helpUrl": ""
    },
    {//當機器人物品辨識出
      "type": "start_when_recognize",
      "message0": "%{BKY_NUWA_WHEN_RECOGNIZE}",
      "args0": [
        {
          "type": "field_dynamic_dropdown",
          "name": "input1",
          "placeholder": "%{BKY_NUWA_PLACEHOLDER_SELECT_AIOBJECT}",
          "options": getAiObjectBlockOptions
        }
      ],
      "nextStatement": null,
      "colour": "%{BKY_NUWA_RECOGNIZE_BLOCK_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_WHEN_RECOGNIZE}",
      "helpUrl": ""
    },
    {//等待機器人辨識到
      "type": "control_wait_recognize",
      "message0": "%{BKY_NUWA_WAIT_RECOGNIZE}",
      "args0": [
        {
          "type": "field_dynamic_dropdown",
          "name": "input1",
          "placeholder": "%{BKY_NUWA_PLACEHOLDER_SELECT_AIOBJECT}",
          "options": getAiObjectBlockOptions
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_RECOGNIZE_BLOCK_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_WAIT_RECOGNIZE}",
      "helpUrl": ""
    },
    {//如果辨識到
      "type": "control_recognize_if",
      "message0": "%{BKY_NUWA_RECOGNIZE_IF}",
      "args0": [
        {
          "type": "field_input",
          "name": "input1",
          "text": "8"
        },
        {
          "type": "field_dynamic_dropdown",
          "name": "input2",
          "placeholder": "%{BKY_NUWA_PLACEHOLDER_SELECT_AIOBJECT}",
          "options": getAiObjectBlockOptions
        },
        {
          "type": "input_dummy"
        },
        {
          "type": "input_statement",
          "name": "input3"
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_RECOGNIZE_BLOCK_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_RECOGNIZE_IF}",
      "helpUrl": ""
    },
    {//如果辨識到，否則
      "type": "control_recognize_ifElse",
      "message0": "%{BKY_NUWA_RECOGNIZE_IF_ELSE}",
      "args0": [
        {
          "type": "field_input",
          "name": "input1",
          "text": "8"
        },
        {
          "type": "field_dynamic_dropdown",
          "name": "input2",
          "placeholder": "%{BKY_NUWA_PLACEHOLDER_SELECT_AIOBJECT}",
          "options": getAiObjectBlockOptions
        },
        {
          "type": "input_dummy"
        },
        {
          "type": "input_statement",
          "name": "input3"
        },
        {
          "type": "input_statement",
          "name": "input4"
        }
      ],
      "previousStatement": null,
      "nextStatement": null,
      "colour": "%{BKY_NUWA_RECOGNIZE_BLOCK_COLOR}",
      "tooltip": "%{BKY_NUWA_TOOLTIP_RECOGNIZE_IF_ELSE}",
      "helpUrl": ""
    }
  ])

  //普通的自定义块不能被放置到有返回值的流程中
  const customBlockChange = initBlockChangeFunc(["procedures_defreturn"], "NUWA_WARN_BLOCK_IN_RETURN");
  cantSuroundedInDefreturnBlocks.forEach(type => {
    if(Blockly.Blocks[type]){
        Blockly.Blocks[type].onchange = customBlockChange;
    }
  });
  //返回开始块不能包包裹的情况
  Blockly.Blocks["start_goto_start"].onchange = initBlockChangeFunc(cantSuroundReturnToStartBlocks, "NUWA_WARN_BLOCK_RETURN_TO_START", true, function(block){
    var c = block.getRootBlock();
    if (c.type !== "start_start") { 
      showBlockWarn(block, Blockly.Msg["NUWA_WARN_BLOCK_RETURN"] || "")
    } else {
      removeBlockWarn(block);
    }
  });
  //结束程序、重置機器人塊不能被放置到有返回值的函數、同時執行塊中
  Blockly.Blocks["stop_excute"].onchange = Blockly.Blocks["reset_robot"].onchange = initBlockChangeFunc(cantSuroundResetRobotBlocks, "NUWA_TEXT_WARN_CANT_SUROUNDED_BY_NORETURN_PARALLE");
  // MQTT连线块不能被放置到同时执行、循环、重复、有返回值的流程中
  // Blockly.Blocks["mqtt_connect"].onchange = initBlockChangeFunc(cantSuroundMqttBlocks, Blockly.Msg["NUWA_TEXT_MQTT_BLOCKS_CANT_SUROUNDED"]);
  //MQTT消息订阅块不能被放置到同时执行、循环、重复、有返回值的流程中，且必须有MQTT连线块被使用
  Blockly.Blocks["mqtt_subscribe_message"].onchange = initBlockChangeFunc(cantSuroundMqttBlocks,"NUWA_TEXT_MQTT_BLOCKS_CANT_SUROUNDED", true, function(block){
    let rootBlock = block.getRootBlock();
    if(rootBlock.type !== "mqtt_connect"){
      showBlockWarn(block, Blockly.Msg["NUWA_TEXT_MUST_AFTER_MATT_BLOCK"]);
    } else {
      removeBlockWarn(block);
    }
  });

  const aiotSubscribe = ['environment_iot', 'ult_iot', 'light_iot']
  aiotSubscribe.forEach(eo => {
      Blockly.Blocks[eo].onchange = initBlockChangeFunc(cantSuroundMqttBlocks,"NUWA_TEXT_MQTT_BLOCKS_CANT_SUROUNDED", true, function(block){
        let rootBlock = block.getRootBlock();
        if(rootBlock.type !== "aiot_connect"){
          showBlockWarn(block, Blockly.Msg["NUWA_TEXT_MUST_AFTER_MATT_BLOCK"]);
        } else {
          removeBlockWarn(block);
        }
      });
  })

  const aiotPublish = ['relay_iot', 'buzzer_iot']
  aiotPublish.forEach(eo => {
    Blockly.Blocks[eo].onchange = initBlockChangeFunc([], "", true, function(block){
      if(!hasMqttConnectBlock('aiot_connect')){
          showBlockWarn(block, Blockly.Msg["NUWA_TEXT_MUST_HAS_MQTT_BLOCK"]);
        } else {
          removeBlockWarn(block);
        }
      });
    })
  // MQTT消息发送块必须有MQTT连线块被使用
  Blockly.Blocks["mqtt_publish"].onchange = initBlockChangeFunc([], "", true, function(block){
    if(!hasMqttConnectBlock('mqtt_connect')){
      showBlockWarn(block, Blockly.Msg["NUWA_TEXT_MUST_HAS_MQTT_BLOCK"]);
    } else {
      removeBlockWarn(block);
    }
  });

  //MQTT消息文本块只能放到MQTT订阅块之内
  Blockly.Blocks["mqtt_message_text"].onchange = initBlockChangeFunc(["mqtt_subscribe_message"], "NUWA_TEXT_MQTT_MESSAGE_TEXT", false);
  Blockly.Blocks["aiot_message_text"].onchange = initBlockChangeFunc(["environment_iot", 'ult_iot', 'light_iot'], "NUWA_TEXT_MQTT_MESSAGE_TEXT", false);
}
